import FacilityFilterPanel from 'src/Admin/components/User/Personas/Providers/Facility';
import '../../../User/association.scss';
const FacilitySelection = ({
  setHasFacilities,
  formFields,
  setSelectedFacilityData,
  selectedFacilityData,
}) => {
  const onSelectedFacilitiesCount = (length) => {
    console.log('length', length);
  };

  const onSetAllFacilities = (value) => {
    console.log('value', value);
    setSelectedFacilityData(value);
    if (value?.length > 0) {
      setHasFacilities(true);
    } else {
      setHasFacilities(false);
    }
  };

  const onSelectedFacilities = (facility) => {
    console.log('facility', facility);
    setSelectedFacilityData(facility);
    if (facility?.length > 0) {
      setHasFacilities(true);
    } else {
      setHasFacilities(false);
    }
  };

  const handleValChange = (event) => {
    console.log('event', event);
  };
  const nextStep = () => {
    console.log('nextStep values');
  };

  return (
    <div className="association-container">
      <FacilityFilterPanel
        label={' Add Facility'}
        updateSelectedItemCount={onSelectedFacilitiesCount}
        handleValChange={handleValChange}
        isContinueClicked={true}
        nextStep={nextStep}
        onSelectedItems={onSelectedFacilities}
        createUserFormData={formFields}
        onSelectAllItems={onSetAllFacilities}
        selectedItemsData={selectedFacilityData}
        selectedFacilityDoctors={selectedFacilityData}
        setSelectedItemsData={setSelectedFacilityData}
        editAffiliatedRecords={true}
      />
    </div>
  );
};

export default FacilitySelection;
